import { NowPlayingSchema, type NowPlaying } from '@mixwire/contracts';

import { nowPlayingStreamUrl } from '../api/spotify.js';

import { useSpotifyStream } from './useSpotifyStream.js';

// This tab's own Spotify playback — a DJ's channel instead reads the party's shared cache,
// kept filled by the server from the line-up, not from whoever has a tab open.
export const useNowPlaying = (): NowPlaying | undefined =>
  useSpotifyStream(nowPlayingStreamUrl, NowPlayingSchema);
